// extracted by mini-css-extract-plugin
export default {"zoomModal":"g3-z"};